package br.com.texeratx.boardgametimeapp.ui.screens.stats

import br.com.texeratx.boardgametimeapp.data.model.stats.GameDurationStatsDTO
import br.com.texeratx.boardgametimeapp.data.model.stats.StatsOverviewDTO
import br.com.texeratx.boardgametimeapp.data.model.stats.YearHistoryDTO
import br.com.texeratx.boardgametimeapp.ui.utils.currentYearFromTodayApiDate

enum class StatsTab { Global, Year, Duration }

data class StatsUiState(
    val isLoading: Boolean = false,
    val error: String? = null,

    val selectedTab: StatsTab = StatsTab.Global,

    val global: StatsOverviewDTO? = null,

    val selectedYear: Int = currentYearFromTodayApiDate(),
    val yearHistory: YearHistoryDTO? = null,

    val durationStats: List<GameDurationStatsDTO> = emptyList(),
)
